module.exports = "<app-hrms-menu></app-hrms-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/hrms.component.html
// module id = ./src/app/hrms/hrms.component.html
// module chunks = main